import React, {useEffect} from 'react';
import {useAddFundRepresentativeForm} from '../../model';
import {ActionModal, ErrorModal, FormInput, useErrorHandler} from '../../../../shared';
import {SelectFund} from '../../../../entities';

interface AddFundRepresentativeModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const AddFundRepresentativeModal = ({open, setOpen}: AddFundRepresentativeModalProps) => {
  const {values, errors, touched, handleChange, handleBlur, setFieldValue, isLoading, submitError, resetForm, submitForm} =
    useAddFundRepresentativeForm({setOpen});

  const {isErrorModalOpen, errorInfo, handleError, handleClose} = useErrorHandler({
    resourceName: 'Представитель Фонда',
    title: 'Ошибка при добавлении представителя фонда',
  });

  useEffect(() => {
    if (submitError) {
      handleError(submitError);
    }
  }, [submitError, handleError]);

  useEffect(() => {
    if (open) {
      resetForm();
    }
  }, [open, resetForm]);

  return (
    <>
      <ActionModal
        open={open}
        onClose={() => setOpen(false)}
        setOpen={() => setOpen(false)}
        resetForm={resetForm}
        submitForm={submitForm}
        isLoading={isLoading}
        isDisabled={!values.fundId || !values.displayName || !values.email}
        size={'m'}
        buttonsSize={'l'}
        caption={'Добавить представителя фонда'}
        textButtonApply={'Добавить'}
        textButtonCancel={'Отменить'}>
        <SelectFund
          value={values.fundId}
          onUpdate={(id) => setFieldValue('fundId', id)}
          error={touched.fundId && errors.fundId ? errors.fundId : undefined}
          placeholder="Выберите фонд"
          size="xl"
        />
        <FormInput
          label="Display name"
          placeholder="Имя"
          name="displayName"
          value={values.displayName}
          onChange={handleChange}
          onBlur={handleBlur}
          error={touched.displayName && errors.displayName}
        />
        <FormInput
          label="E-mail"
          placeholder="example@mail.com"
          name="email"
          value={values.email}
          onChange={handleChange}
          onBlur={handleBlur}
          error={touched.email && errors.email}
        />
      </ActionModal>
      <ErrorModal open={isErrorModalOpen} onClose={handleClose} title={errorInfo.title} message={errorInfo.message} />
    </>
  );
};
